import { map, pick } from 'lodash'

const transformToSaveFoodMoodsArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, ['id', 'name', 'position']),
    position: index,
  }))

export default transformToSaveFoodMoodsArgs
